import { SortDescriptor } from "react-aria-components";

export const compareModuleVersionValues = (a: string, b: string, direction: number) =>
  a.localeCompare(b, undefined, { numeric: true }) * direction;

export const toModuleVersionSortDirection = (sortDescriptor: SortDescriptor) =>
  sortDescriptor.direction === "ascending" ? 1 : -1;

export const sortModuleVersionRowsById = <T extends { id: string }>(
  rows: T[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return rows;
  }

  const direction = toModuleVersionSortDirection(sortDescriptor);

  return [...rows].sort((a, b) => compareModuleVersionValues(a.id, b.id, direction));
};
